import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const getRegionsAsync = createAsyncThunk(
  'rfxManagement/rfi/getRegionsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfx-analysis/rfi/get-regions', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getCategoriesAsync = createAsyncThunk(
  'rfxManagement/rfx-analysis/get-categories',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfx-analysis/get-categories', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getCustomCategoriesAsync = createAsyncThunk(
  'rfxManagement/rfx-analysis/get-custom-categories',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfx-analysis/get-custom-categories', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const deleteCustomCategoriesAsync = createAsyncThunk(
  'rfxManagement/rfx-analysis/delete-custom-categories',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/delete-custom-categories', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const addCustomCategoriesAsync = createAsyncThunk(
  'rfxManagement/rfx-analysis/add-project-categories',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/add-project-categories', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getPreviewFilePathInTemplateLibrary = createAsyncThunk(
  'rfxManagement/rfx-analysis/preview-template-from-library',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/preview-template-from-library', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getSasTokenAsync = createAsyncThunk(
  'rfxManagement/rfp/getSasTokenAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-sas-token-v2', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const whitelistIpAsync = createAsyncThunk(
  'rfxManagement/rfx/whitelistIpAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/whitelist-ip', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getTagsAsync = createAsyncThunk(
  'rfxManagement/rfi/getTagsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-tags', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// export const getTemplateListAsync = createAsyncThunk(
//   'rfxManagement/rfi/getTemplateListAsync',
//   async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
//     return await AxiosClient('POST', '/v1/rfx-mgmt/rfi-analysis/get-template-list', payload, {
//       dispatch,
//       rejectWithValue,
//       fulfillWithValue,
//     })
//   },
// )

export const getRFITemplatesListAsync = createAsyncThunk(
  'rfxManagement/rfi/getRFITemplateListAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-mgmt/rfi-analysis/get-rfi-templates', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getVendorTrackingForProjectAsync = createAsyncThunk(
  'vendorTracker/getVendorTrackingForProjectAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v2/vendor-tracker/get-vendor-tracking-for-project',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const updateVendorStatusLogsAsync = createAsyncThunk(
  'vendorTracker/updateVendorStatusLogsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/vendor-tracker/update-vendor-status-row-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getRfxConsolidationStatusAsync = createAsyncThunk(
  'rfxManagement/rfi/rfx-analysis/get-consolidation-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-consolidation-status', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const downloadConsolidatedRFXAsync = createAsyncThunk(
  'rfxManagement/rfi/rfx-analysis/get-consolidated-bids',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-consolidated-bids', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getRFXConsolidationFilePath = createAsyncThunk(
  'rfxAnalysis/getConsolidationFilePath',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await AxiosClient(
        'POST',
        '/v1/rfx-analysis/get-consolidation-filepath',
        payload,
        { dispatch, rejectWithValue, fulfillWithValue },
      )
      return response
    } catch (error) {
      console.error('Error fetching consolidation file path:', error)
      return rejectWithValue(error.message)
    }
  },
)

export const generateRFIConsolidation = createAsyncThunk(
  'rfxManagement/rfx/project-details/genarate-consolidated-bids',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/genarate-consolidated-rfi', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getSheetsNamesForConsolidationForRfi = createAsyncThunk(
  'rfxAnalysis/getSheetsNamesForConsolidation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await AxiosClient(
        'POST',
        'v1/rfx-analysis/get-sheets-names-for-consolidation',
        payload,
        { dispatch, rejectWithValue, fulfillWithValue },
      )
      return response
    } catch (error) {
      console.error('Error fetching sheets names for consolidation:', error)
      return rejectWithValue(error.message)
    }
  },
)

export const downloadRfxConsolidation = createAsyncThunk(
  'rfxAnalysis/downloadConsolidation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await AxiosClient(
        'POST',
        '/v1/rfx-analysis/download_consolidation',
        payload,
        { dispatch, rejectWithValue, fulfillWithValue },
      )
      return response
    } catch (error) {
      console.error('Error downloading consolidation file:', error)
      return rejectWithValue(error.message)
    }
  },
)

export const addVendorTrackerColumnAsync = createAsyncThunk(
  'vendorTracker/addVendorTrackerColumn',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/vendor-tracker/update-vendor-status-logs', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// export const getRfiFiltersAsync = createAsyncThunk(
//   'rfxManagement/rfi/getRfiFiltersAsync',
//   async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
//     return await AxiosClient('POST', '/v1/rfx-mgmt/rfi-analysis/get-filter-data', payload, {
//       dispatch,
//       rejectWithValue,
//       fulfillWithValue,
//     })
//   },
// )
export const getProjectsDetailsAsync = createAsyncThunk(
  'rfxManagement/rfi/getProjectsDetailsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/rfi/get-project-details', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get RFI KPIs
export const getRFIKPIs = createAsyncThunk(
  'rfxManagement/rfi/kpis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfx-mgmt/rfi-analysis/get-kpis-data', [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// export const uploadRfiTemplateAsync = createAsyncThunk(
//   'rfxManagement/rfi',
//   async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
//     return await AxiosClient('POST', '/v1/rfx-mgmt/rfi-analysis/upload-template', payload, {
//       dispatch,
//       rejectWithValue,
//       fulfillWithValue,
//     })
//   },
// )

// export const getProjectsStatusesAsync = createAsyncThunk(
//   'rfxManagement/rfi/getProjectsStatusesAsync',
//   async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
//     return await AxiosClient(
//       'GET',
//       '/v1/rfx-mgmt/rfi-analysis/get-project-lifecycle',
//       {},
//       { dispatch, rejectWithValue, fulfillWithValue },
//     )
//   },
// )

// RFI project details KPIs
export const getRFIProjectDetailsKPIsAsync = createAsyncThunk(
  'rfxManagement/rfi/project-details/kpis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-project-details-kpi', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//shortlist vendors
export const shortlistVendorAsync = createAsyncThunk(
  'rfxManagement/rfp/shortlist-vendor',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/rfx-analysis/rfi/shortlist-vendors', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Download consolidated file
// export const downloadConsolidatedRFIAsync = createAsyncThunk(
//   'rfxManagement/rfi/project-details/download-consolidated-rfi',
//   async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
//     return await AxiosClient(
//       'POST',
//       '/v1/rfx-mgmt/rfi-analysis/get-consolidated-summary',
//       payload,
//       { dispatch, rejectWithValue, fulfillWithValue },
//     )
//   },
// )

//Download vendors data file
// export const downloadVendorsAsync = createAsyncThunk(
//   'rfxManagement/rfi/project-details/download-vendors-rfi',
//   async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
//     return await AxiosClient('POST', '/v1/rfx-mgmt/rfi-analysis/get-vendors-summary', payload, {
//       dispatch,
//       rejectWithValue,
//       fulfillWithValue,
//     })
//   },
// )

//Download Standard GTO template
// export const downloadGtoStandardTemplate = createAsyncThunk(
//   'rfxManagement/rfi/project-details/download-GTO-standard-temp',
//   async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
//     return await AxiosClient('POST', 'v1/rfx-mgmt/rfi-analysis/download-file', payload, {
//       dispatch,
//       rejectWithValue,
//       fulfillWithValue,
//     })
//   },
// )

//Get contact details for RFI vendor
export const GetContactDetailsforVendorAsync = createAsyncThunk(
  'rfxManagement/rfi/get-contact-details-for-vendor',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfx-mgmt/get-rfi-project-contacts', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Async for RFI Vendors data (Emails and key_contact_person)
// export const getVendorsMappingDataAsync = createAsyncThunk(
//   'rfxManagement/rfi/project-details/VendorsMappingDataAsync',
//   async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
//     return await AxiosClient(
//       'POST',
//       'v1/rfx-mgmt/rfi-analysis/get-project-supplier-details',
//       payload,
//       {
//         dispatch,
//         rejectWithValue,
//         fulfillWithValue,
//       },
//     )
//   },
// )

//Async for send RFI mail
export const sendRFIEmailAsync = createAsyncThunk(
  'rfxManagement/rfi/project-details/sendRFIEmailAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfx-mgmt/rfi-analysis/send-rfi-mail', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//api/v1/rfx-mgmt/rfi-analysis/shortlist-vendors
// export const setShortlistedVendorsAsync = createAsyncThunk(
//   'rfxManagement/rfi/project-details/get-all-vendor-details-with-responses',
//   async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
//     return await AxiosClient('POST', 'v1/rfx-mgmt/rfi-analysis/shortlist-vendors', payload, {
//       dispatch,
//       rejectWithValue,
//       fulfillWithValue,
//     })
//   },
// )

//Download uploaded vendors with errors
export const downloadVendorsWithErrors = createAsyncThunk(
  'rfxManagement/rfx-analysis/download-supplier-upload-error-file',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfx-analysis/download-supplier-upload-error-file',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//Get Mail Responses
export const GetMailResponsesForVendor = createAsyncThunk(
  'rfxManagement/rfi/emails/vendor-response',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-mgmt/rfi-analysis/get-vendor-conversation', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Get Mail Attachments
export const GetMailAttachmentsForVendor = createAsyncThunk(
  'rfxManagement/rfi/emails/vendor-response-attachments',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfx-mgmt/rfi-analysis/get-vendor-conversation-attachments',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//rfp upload
export const UploadRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/rfp-upload',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/upload-rfp/upload-supplier-bid-details', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Download RFI file
// export const downloadRFIBlobFileAsync = createAsyncThunk(
//   'rfxManagement/rfi/download-rfi-blob-file',
//   async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
//     return await AxiosClient('POST', '/v1/rfx-mgmt/rfi-analysis/download-blob-file', payload, {
//       dispatch,
//       rejectWithValue,
//       fulfillWithValue,
//     })
//   },
// )

//Upload RFI and additional files
// export const uploadRFIandAdditionalFilesAsync = createAsyncThunk(
//   'rfxManagement/rfi/download-rfi-blob-file',
//   async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
//     return await AxiosClient('POST', '/v2/rfx-mgmt/upload-template', payload, {
//       dispatch,
//       rejectWithValue,
//       fulfillWithValue,
//     })
//   },
// )

//rfi-rfp integration

//Create project rfi
export const createProjectInformationAsync = createAsyncThunk(
  'rfxManagement/rfi/createProjectInformationAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/create-project', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//edit rfi project
export const editProjectInformationAsync = createAsyncThunk(
  'rfxManagement/rfi/editProjectInformationAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/edit-project-details', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Change default mail template
export const changeRFIDefaultTemplate = createAsyncThunk(
  'rfxManagement/rfi/default-email-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/default-email-template', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Change default mail template
export const getRFIDefaultTemplate = createAsyncThunk(
  'rfxManagement/rfi/get-email-templates',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-email-templates', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      // isRejectWithErrorMsg: true,
    })
  },
)

export const sendRFIEmailCommunicationAsync = createAsyncThunk(
  'rfxManagement/rfi/project-details/send-communication',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/send-communication', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//Upload Questionnaire and nda files
export const UploadFilesForRFI = createAsyncThunk(
  'rfxManagement/rfx-analysis/upload-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/upload-template', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//Upload Questionnaire and nda files
export const UploadFilesForRFIv2 = createAsyncThunk(
  'rfxManagement/rfx-analysis/upload-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/upload-template_v2', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//Async for Table in project deatil page
export const getProjectVendorsDataAsync = createAsyncThunk(
  'rfxManagement/rfi/project-details/get-all-vendor-details-with-responses',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfx-analysis/get-all-vendor-details-with-responses',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

//get filters for rfx
export const getRfxFilters = createAsyncThunk(
  'rfxManagement/rfx-analysis/get-filters',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-filters', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      // isRejectWithErrorMsg: true,
    })
  },
)

//get project details for rfx
export const getRfxProjectDetails = createAsyncThunk(
  'rfxManagement/rfx-analysis/get-project-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-project-details', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      // isRejectWithErrorMsg: true,
    })
  },
)

//get project life cycle for rfx
export const getRfxProjectLifeCycle = createAsyncThunk(
  'rfxManagement/rfx-analysis/get-project-round-lifecycle',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-project-round-lifecycle', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      // isRejectWithErrorMsg: true,
    })
  },
)
//get project life cycle for rfx
export const getRfxProjectWithPagination = createAsyncThunk(
  'v1/rfx-analysis/get-project-details-with-pagination',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfx-analysis/get-project-details-with-pagination',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        // isRejectWithErrorMsg: true,
      },
    )
  },
)

//get project life cycle for rfx
export const getRfxProjectKpiData = createAsyncThunk(
  'rfxManagement/rfx-analysis/get-kpis-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfx-analysis/get-kpis-data', [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      // isRejectWithErrorMsg: true,
    })
  },
)

// Upload Vendors
export const uploadVendorsAsyncRfi = createAsyncThunk(
  'rfxManagement/rfi/project-details/upload-vendors',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/upload-suppliers', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//Update contact details for vendor
export const UpdateContactforVendorAsync = createAsyncThunk(
  'rfxManagement/rfx-analysis/add-rfi-contact',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/add-rfi-contact', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get RFI project templates
export const getRFIProjectTemplates = createAsyncThunk(
  'rfxManagement/rfx-analysis/get-rfi-project-templates',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-rfx-templates', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      // isRejectWithErrorMsg: true,
    })
  },
)

//Send RFI via GTO Email
export const sendRFIViaGtoEmail = createAsyncThunk(
  'rfxManagement/rfx-analysis/send-RFI-via-GTO-Email',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/send-rfi-mail', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//Send RFI via GTO Email
export const sendTestMailRFIViaGtoEmail = createAsyncThunk(
  'rfxManagement/rfx-analysis/send-RFI-test-mail-via-GTO-Email',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/send-test-mail', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
//Get Contacts details for RFI project
export const getContactDetailsforRFIProject = createAsyncThunk(
  'rfxManagement/rfx-analysis/get-contact-details-for-RFI-project',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-rfi-project-contacts', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      // isRejectWithErrorMsg: true,
    })
  },
)

//Generate common url for RFI emails
export const generateCommonURLforRFI = createAsyncThunk(
  'rfxManagement/rfx-analysis/rfi-generate-common-url',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/generate-common-url', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      // isRejectWithErrorMsg: true,
    })
  },
)

//Change RFI status
export const changeRFIStatus = createAsyncThunk(
  'rfxManagement/rfx-analysis/change-rfi-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/change-status', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      // isRejectWithErrorMsg: true,
    })
  },
)

// Delete Vendors from RFI project
export const deleteVendorsFromRFIProject = createAsyncThunk(
  'rfxManagement/rfx-analysis/delete-rfi-vendors',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/delete-vendor', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      // isRejectWithErrorMsg: true,
    })
  },
)

export const deleteTagsAndColorsAsyncRfi = createAsyncThunk(
  'rfxManagement/rfx/deleteTagsAndColorsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/delete-vendor-tags', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// upload filled RFI, NDA and additional files

export const UploadFilesAsync = createAsyncThunk(
  'rfxManagement/rfx-analysis/upload-files',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/upload-files', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
export const UploadFilesAsyncv2 = createAsyncThunk(
  'rfxManagement/rfx-analysis/upload-files',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/upload-files_v2', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const cancelRfiUploadAsync = createAsyncThunk(
  'rfxManagement/rfx-analysis/cancel-upload-files',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/upload-files/abort', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectedWithValue: true,
    })
  },
)

//File list of RFI vendor
export const getFileListForRFIVendor = createAsyncThunk(
  'rfxManagement/rfx-analysis/vendor-file-list',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/vendor-file-lists', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Delete RFx project
// export const deleteProjectAsync = createAsyncThunk(
//   'rfxManagement/rfx-analysis/delete-RFx-project',
//   async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
//     return await AxiosClient('POST', '/v1/rfx-analysis/delete-project', payload, {
//       dispatch,
//       rejectWithValue,
//       fulfillWithValue,
//     })
//   },
// )

// add project to rfp
export const addProjectToRfp = createAsyncThunk(
  'rfxManagement/rfi/project-details/move-rfi-to-rfp',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/move-to-rfp', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//Download RFI and NDA files
export const downloadRFIAndAdditionalFilesAsync = createAsyncThunk(
  'rfxManagement/rfx-analysis/download-files',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfx-analysis/download-files',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
      'blob',
    )
  },
)

//list-request-for-vendors
export const getRequestVendorListforRFI = createAsyncThunk(
  'rfxManagement/rfi/list-request-vendors',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/list-request-for-vendor', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Approve vendor contact
export const approveVendorContactForRFI = createAsyncThunk(
  'rfxManagement/rfi/approve-request-for-multiple-contacts',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfx-analysis/approve-request-for-multiple-contacts',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//Attached rfi nda templates
export const getRFITemplateFileList = createAsyncThunk(
  'rfxManagement/rfx-analysis/get-rfi-templates-list',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-rfi-templates-list', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//download-rfi-templates
export const DownloadRFIFiles = createAsyncThunk(
  'rfxManagement/rfx-analysis/download-rfi-templates-list',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfx-analysis/download-rfi-templates-list',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
      'blob',
    )
  },
)

//delete RFI template files
export const DeleteRFIFiles = createAsyncThunk(
  'rfxManagement/rfx-analysis/delete_file',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/delete_file', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Get uploaded vendor error status
export const downloadVendorsWithErrorsStatus = createAsyncThunk(
  'rfxManagement/rfx-analysis/check-file-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/check-file-status', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//Get RFP project status for RFI
export const getRFPProjectStatus = createAsyncThunk(
  'rfxManagement/rfx-analysis/rfp-project-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-rfp-project-details', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get archived RFx projects
export const getArchivedRfxProjects = createAsyncThunk(
  'rfxManagement/rfx-analysis/archived-projects',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfx-analysis/get-archive-projects', [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      // isRejectWithErrorMsg: true,
    })
  },
)

export const setRFIReminders = createAsyncThunk(
  'rfxManagement/rfi-analysis/set-reminders',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/set-reminders', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const setRFXEvents = createAsyncThunk(
  'rfxManagement/rfx-analysis/set-events',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfx-analysis/events', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const deleteReminders = createAsyncThunk(
  'rfxManagement/rfx-analysis/delete-reminders',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/delete-reminders', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getReminders = createAsyncThunk(
  'rfxManagement/rfx-analysis/get-reminders',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-reminders', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const updateRFIReminders = createAsyncThunk(
  'rfxManagement/rfx-analysis/update-RFI-Reminders',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/update-reminders', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Archive RFx project
export const archiveUnarchiveRFxProjectAsync = createAsyncThunk(
  'rfxManagement/rfx-analysis/archive-RFx-project',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/archive-unarchive-project', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get template library details
export const getTemplateLibraryDetailsAsync = createAsyncThunk(
  'rfxManagement/rfx-analysis/template-library',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfx-analysis/get-rfx-templates-from-library', [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Template library Upload
export const templateLibraryUploadAsync = createAsyncThunk(
  'rfxManagement/rfx-analysis/template-library-upload',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/upload-template-to-library', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const templateLibraryEditUploadAsync = createAsyncThunk(
  'rfxManagement/rfx-analysis/template-edit-library-upload',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfx-analysis/update-rfx-templates-from-library',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const deleteRfxTemplateFromLibraryAsync = createAsyncThunk(
  'rfxManagement/rfx-analysis/template-library-delete',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfx-analysis/delete-rfx-templates-from-library',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const getRfxTemplatesFromLibraryByFilenameAsync = createAsyncThunk(
  'rfxManagement/rfx-analysis/template-library-upload',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfx-analysis/get-rfx-templates-from-library-by-filename',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//Template library Download single file
export const templateLibraryDownloadSingleFileAsync = createAsyncThunk(
  'rfxManagement/rfx-analysis/template-library-download-single',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/download-template-from-library', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Template library Download zip file
export const templateLibraryDownloadZipFileAsync = createAsyncThunk(
  'rfxManagement/rfx-analysis/template-library-download-zip',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfx-analysis/download-multiple-template-from-library',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const addContactForRFIProject = createAsyncThunk(
  'rfxManagement/add-new-contacts-to-vendor',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/add-new-contacts-to-vendor', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      // isRejectWithErrorMsg: true,
    })
  },
)

//email status tracker

export const getRFIVendorEmailStatus = createAsyncThunk(
  'rfx-analysis/get-mail-data-for-vendors',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-mail-data-for-vendors', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Refresh status
export const refreshRFIVendorEmailStatus = createAsyncThunk(
  'rfx-analysis/refresh-mail-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/refresh-mail-status', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
export const insertDeleteTagsAsync = createAsyncThunk(
  'bid-analysis/get-insert-update-tags-async',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/add-vendor-tags', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getRFIFileHistory = createAsyncThunk(
  'rfxManagement/rfi/get-rfi-templates-list-with-history',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfx-analysis/get-rfi-templates-list-with-history',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

export const getFilenameAsync = createAsyncThunk(
  'rfxManagement/rfx/getFilenameAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-filename', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getViewFeedback = createAsyncThunk(
  'rfxManagement/rfx/feedback/viewFeedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/feedback-generation/get-feedback-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const updateHtsForCategory = createAsyncThunk(
  'landedCostAnalysis/updateHtsForCategory',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/landed-cost-analysis/update-hts-for-category', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getOriginTariffData = createAsyncThunk(
  'landedCostAnalysis/getOriginTariffData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/landed-cost-analysis/get-origin-tariff-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// For RFP Analysis
export const fetchRfpCustomTemplatesAsync = createAsyncThunk(
  'rfpAnalysis/templates/fetchRfpCustomTemplatesAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/fetch-custom-templates', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// For RFX Analysis
export const fetchRfxCustomTemplatesAsync = createAsyncThunk(
  'rfxAnalysis/templates/fetchRfxCustomTemplatesAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/fetch-custom-templates', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
